import { setHours, setMinutes } from "date-fns";

export class TimeOfDay {
  constructor(
    public readonly hour: number,
    public readonly minute: number,
  ) {
    if (hour < 0 || hour > 23) {
      throw new Error(
        `An hour value should be between 0 and 23 (including). Given: "${hour}"`,
      );
    }

    if (minute < 0 || minute > 59) {
      throw new Error(
        `A minute value should be between 0 and 59 (including). Given: "${minute}"`,
      );
    }

    Object.freeze(this);
  }

  public static fromStringTime(time: string): TimeOfDay {
    const timeArray = time.split(":");
    if (timeArray.length !== 2) {
      throw new Error(`Fail to extract the hour from the string "${time}"`);
    }

    const [hour, minute] = timeArray;

    return new TimeOfDay(parseInt(hour), parseInt(minute));
  }

  public static fromDateTime(dateTime: Date): TimeOfDay {
    const hour = dateTime.getHours();
    const minute = dateTime.getMinutes();

    return new TimeOfDay(hour, minute);
  }

  public asHours(): string {
    return (
      this.hour.toString().padStart(2, "0") +
      ":" +
      this.minute.toString().padStart(2, "0")
    );
  }

  public asDate(today = new Date()): Date {
    return setMinutes(setHours(today, this.hour), this.minute);
  }

  public addHour(hour: number): TimeOfDay {
    return new TimeOfDay((this.hour + hour) % 24, this.minute);
  }
}
